interface Props {
    className?: string
    pathClassName?: string
    FillColor?: string
}

export default function BurgerMenu({
                                       className = '',
                                       pathClassName = '',
                                       FillColor = 'black'
                                    }:Props) {
    return (
        <svg
            className={className}
            width="40"
            height="40"
            viewBox="0 0 24 24"
        >
            <path
                d="M3 7.2C3 6.53726 3.53726 6 4.2 6H20.7C20.8657 6 21 6.13431 21 6.3C21 6.96274 20.4627 7.5 19.8 7.5H3.3C3.13431 7.5 3 7.36569 3 7.2Z"
                fill={FillColor}
                className={pathClassName}
            />
            <path
                d="M3 12.45C3 11.7873 3.53726 11.25 4.2 11.25H20.7C20.8657 11.25 21 11.3843 21 11.55C21 12.2127 20.4627 12.75 19.8 12.75H3.3C3.13431 12.75 3 12.6157 3 12.45Z"
                fill={FillColor}
            />
            <path
                d="M3 17.7C3 17.0373 3.53726 16.5 4.2 16.5H20.7C20.8657 16.5 21 16.6343 21 16.8C21 17.4627 20.4627 18 19.8 18H3.3C3.13431 18 3 17.8657 3 17.7Z"
                fill={FillColor}
            />
        </svg>
    )
}
